import React, { useState, useEffect } from "react";
import useSendEvents from "../hooks/useSendEvents";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../styles/CarosuelProducts.css";

const CarosuelProducts = ({ data }) => {
  const [slidesPerView, setSlidesPerView] = useState(1);

  const carouselData = data[0];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) setSlidesPerView(1);
      else if (window.innerWidth <= 1024) setSlidesPerView(2);
      else setSlidesPerView(3);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { handleEvent, handleEventWithCallBackAction } = useSendEvents();

  return (
    <div className="w-full my-10 bg-[#f5f9fb] pb-20">
      <div className="flex flex-col text-center xs:px-4 pt-32">
        <h1 className="text-5xl xs:text-start 2xl:text-4xl">
          {carouselData.title}
        </h1>
        <p className="text-xl xs:text-start xs:pt-4">
          {carouselData.textRegular}
        </p>
      </div>

      <section className="mx-auto max-w-7xl mt-10 overflow-hidden xs:mt-2 relative 2xl:max-w-6xl">
        <Swiper
          modules={[Pagination]}
          slidesPerView={slidesPerView}
          spaceBetween={30}
          pagination={{
            clickable: true
          }}
          breakpoints={{
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            }
          }}
          className="w-full"
        >
          {carouselData.solution.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="grid grid-rows-2 h-full mx-2">
                <div className="bg-[#CEDEE7] h-full relative">
                  {item.cardImage && (
                    <img
                      src={item.cardImage}
                      alt={item.title}
                      className="w-full h-full object-contain"
                    />
                  )}
                </div>
                <div className="px-4 bg-white flex flex-col justify-between py-5 min-h-[400px]">
                  <h3 className="text-2xl mb-3 lg:text-lg xs:text-xl 2xl:text-2xl">
                    {item.title}
                  </h3>
                  <div className="space-y-2">
                    <p className="text-lg lg:text-base xs:text-base 2xl:text-medium text-gray-600">
                      {item.textRegular}
                    </p>
                    {item.textRegularTwo && (
                      <p className="text-sm 2xl:text-xs text-gray-500">
                        {item.textRegularTwo}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Paginación */}
        <div className="swiper-pagination"></div>
      </section>

      {/* Estilos personalizados para los bullets */}
      <style>{`
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          margin: 0 6px;
          opacity: 0.5;
          background-color: black;
          border-radius: 100%;
          transition: all 0.3s ease;
        }
        .swiper-pagination-bullet-active {
          opacity: 1;
          background-color: #EC0000 !important;
        }
      `}</style>
    </div>
  );
};

export default CarosuelProducts;